import { configureStore } from '@reduxjs/toolkit';

import { getAsyncLSSetter, setLS } from '../utils/storage';
import api from './slices/api';
import settings from './slices/settings';
import theme from './slices/theme';

export const store = configureStore({
  reducer: {
    api: api.reducer,
    settings: settings.reducer,
    theme: theme.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(api.middleware)
      .prepend(settings.middleware)
      .prepend(theme.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

function persistedApiState() {
  const { data, historys } = store.getState().api;
  return { data, historys };
}

const saveApiState = getAsyncLSSetter<ReturnType<typeof persistedApiState>>('api');
let previousApiState = store.getState().api;
store.subscribe(() => {
  const nextApiState = store.getState().api;
  if (nextApiState !== previousApiState) {
    previousApiState = nextApiState;
    saveApiState(persistedApiState());
  }
});

export function persistApiState() {
  setLS('api', persistedApiState());
}
